import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {AfriexReferralTier} from '@/types';

import SignupBonusFormModal from './SignupBonusFormModal';

type SignupBonusUpdateButtonProps = {
  initialData?: AfriexReferralTier;
};

const SignupBonusUpdateButton = ({
  initialData,
}: SignupBonusUpdateButtonProps): ReactElement => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const updateLabel = isEmpty(initialData)
    ? 'Create Signup Bonus Code +'
    : 'Update Signup Bonus Code';
  const toggleFullScreen = () => {
    setShowFullScreen(!showFullScreen);
  };

  return showFullScreen ? (
    <SignupBonusFormModal
      isOpen={showFullScreen}
      onClose={toggleFullScreen}
      data={initialData}
    />
  ) : (
    <Button variant="solid" colorScheme="cyan" onClick={toggleFullScreen}>
      {updateLabel}
    </Button>
  );
};

export default SignupBonusUpdateButton;
